module.exports = __webpack_public_path__ + "img/ch68.c6f8052d.png";